import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import productTcService from "services/Setup/Organization/productTcService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  productTCDetail: {},
  productTcList: {},
};

export const postproductTc = createAsyncThunk(
  "productTc/postproductTc",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productTcService.postProductTc(data);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getProductTcList = createAsyncThunk(
  "productTc/getProductTcList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productTcService.getProductTcList(data);
      if (response.status === 200) {
        if (response && response.data) {
          return response;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getProductTcDetail = createAsyncThunk(
  "productTc/getProductTcDetail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productTcService.getProductTcDetail(data);
      if (response.status === 200) {
        if (response && response.data) {
          return response;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateProductTc = createAsyncThunk(
  "productTc/updateProductTc",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productTcService.updateProductTc(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteProductTc = createAsyncThunk(
  "productTc/deleteProductTc",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productTcService.deleteProductTc(data);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
export const returnProductTc = createAsyncThunk(
  "productTc/returnProductTc",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productTcService.returnProductTc(data);
      console.log("🚀 ~ response:", response);
      // // Mendapatkan data dari local storage
      // const storedData = localStorage.getItem("myIdList");

      // // Mengonversi data dari string JSON ke dalam bentuk array objek
      // const parsedData = storedData ? JSON.parse(storedData) : [];

      // // Mencari indeks ID dalam array
      // const index = parsedData.findIndex((item) => item.id === data.id);

      // // Jika ID sudah ada, tingkatkan nilai akses
      // if (index !== -1) {
      //   parsedData[index].akses += 1;
      // } else {
      //   // Jika ID belum ada, tambahkan ID baru dengan akses 1
      //   parsedData.push({ id: data.id, akses: 1 });
      // }

      // // Menyimpan kembali data dalam local storage
      // localStorage.setItem("myIdList", JSON.stringify(parsedData));

      // Memastikan respons dan respons.data tidak undefined
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
export const approveProductTc = createAsyncThunk(
  "productTc/approveProductTc",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productTcService.approveProductTc(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
export const requestProductTc = createAsyncThunk(
  "productTc/requestProductTc",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productTcService.requestProductTc(data);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
export const rejectProductTc = createAsyncThunk(
  "productTc/rejectProductTc",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productTcService.rejectProductTc(data);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const productTcSlice = createSlice({
  name: "productTC",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //post
      .addCase(postproductTc.pending, (state) => {
        state.loading = true;
      })
      .addCase(postproductTc.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.productTCDetail = action.payload;
      })
      .addCase(postproductTc.rejected, (state, action) => {
        state.loading = false;
        state.productTCDetail = action.payload;
        state.showMessage = true;
      })
      //list
      .addCase(getProductTcList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getProductTcList.fulfilled, (state, action) => {
        state.loading = false;
        state.productTcList = action.payload;
      })
      .addCase(getProductTcList.rejected, (state, action) => {
        state.loading = false;
        state.productTCDetail = action.payload;
        state.showMessage = true;
      })
      //detail
      .addCase(getProductTcDetail.pending, (state) => {
        if (state.productTCDetail == []) {
          state.loading = true;
        }
      })
      .addCase(getProductTcDetail.fulfilled, (state, action) => {
        if (state.productTCDetail == []) {
          state.loading = false;
        }
        state.productTCDetail = action.payload;
      })
      .addCase(getProductTcDetail.rejected, (state, action) => {
        if (state.productTCDetail == []) {
          state.loading = false;
        }
        state.productTCDetail = action.payload;
        state.showMessage = true;
      })

      //update
      .addCase(updateProductTc.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProductTc.fulfilled, (state, action) => {
        state.loading = false;
        // state.redirect = '/'
        // state.productTCDetail = action.payload
      })
      .addCase(updateProductTc.rejected, (state, action) => {
        state.loading = false;
        state.productTCDetail = action.payload;
        state.showMessage = true;
      })
      //delete
      .addCase(deleteProductTc.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteProductTc.fulfilled, (state, action) => {
        state.loading = false;
        state.productTCDetail = action.payload;
      })
      .addCase(deleteProductTc.rejected, (state, action) => {
        state.loading = false;
        state.productTCDetail = action.payload;
        state.showMessage = true;
      })
      // Return
      .addCase(returnProductTc.pending, (state) => {
        state.loading = true;
      })
      .addCase(returnProductTc.fulfilled, (state, action) => {
        state.loading = false;
        state.productTCDetail = action.payload;
      })
      .addCase(returnProductTc.rejected, (state, action) => {
        state.loading = false;
        state.productTCDetail = action.payload;
        state.showMessage = true;
      })
      // Approve
      .addCase(approveProductTc.pending, (state) => {
        state.loading = true;
      })
      .addCase(approveProductTc.fulfilled, (state, action) => {
        state.loading = false;
        state.productTCDetail = action.payload;
      })
      .addCase(approveProductTc.rejected, (state, action) => {
        state.loading = false;
        state.productTCDetail = action.payload;
        state.showMessage = true;
      })
      // Approve
      .addCase(requestProductTc.pending, (state) => {
        state.loading = true;
      })
      .addCase(requestProductTc.fulfilled, (state, action) => {
        state.loading = false;
        state.productTCDetail = action.payload;
      })
      .addCase(requestProductTc.rejected, (state, action) => {
        state.loading = false;
        state.productTCDetail = action.payload;
        state.showMessage = true;
      })
      // Reject
      .addCase(rejectProductTc.pending, (state) => {
        state.loading = true;
      })
      .addCase(rejectProductTc.fulfilled, (state, action) => {
        state.loading = false;
        state.productTCDetail = action.payload;
      })
      .addCase(rejectProductTc.rejected, (state, action) => {
        state.loading = false;
        state.productTCDetail = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  productTcSlice.actions;

export default productTcSlice.reducer;
